export default "__VITE_ASSET__5fc5ca0e__"